import { rankingItems } from '@/mocks/home';

const getTagStyle = (tag: string) => {
  switch (tag) {
    case '新': return 'bg-primary-100 text-primary-700';
    case '荐': return 'bg-accent-100 text-accent-700';
    case '热': return 'bg-primary-100 text-primary-700';
    case '追': return 'bg-accent-100 text-accent-700';
    case '待': return 'bg-secondary-100 text-secondary-700';
    default: return 'bg-secondary-100 text-secondary-700';
  }
};

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              热度榜单
            </h2>
          </div>

          <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
            <div className="divide-y divide-background-200/40">
              {rankingItems.map((item) => (
                <a
                  key={item.rank}
                  href="#ranking"
                  className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 hover:bg-background-100 transition-colors cursor-pointer group"
                >
                  <span
                    className={`w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold shrink-0 ${
                      item.rank <= 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </span>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-0.5">
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                        {item.title}
                      </h3>
                      <span className={`px-1.5 py-0.5 text-[10px] font-medium rounded ${getTagStyle(item.tag)}`}>
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-xs text-foreground-500 line-clamp-1">
                      {item.subtitle}
                    </p>
                  </div>

                  <div className="text-right shrink-0 hidden sm:block">
                    <div className="text-sm font-bold text-accent-600">{item.score}</div>
                    <div className="text-[10px] text-foreground-400">{item.hot}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}